import { FunctionalComponent, h } from 'preact';
interface ServiceButton {
	label: string;
	expanded: boolean;
	toggle: () => any;
	id: string;
}

const handleKeyDownSpaceBar = (e: KeyboardEvent, cb: () => void) => {
	if (e.key === ' ' || e.key === 'Enter') {
		cb();
	}
};

export const ServiceCardButton: FunctionalComponent<ServiceButton> = (props) => {
	const { label, expanded, id, toggle } = props;
	return (
		<div
			role="button"
			aria-expanded={expanded}
			aria-controls={id}
			onKeyDown={(e) => handleKeyDownSpaceBar(e, toggle)}
			onClick={toggle}
			className="SP-ServiceCard__button"
			tabIndex={0}
		>
			<h2 className="SP-ServiceCard__headline--mobile">{label}</h2>
			<svg className="SPi SPi-customer-arrow-down SPi-Toc__dropdown" aria-hidden="true" focusable="false">
				<use href="#SPi-customer-arrow-down" />
			</svg>
		</div>
	);
};
